import { render, staticRenderFns } from "./BotaoSucursales.vue?vue&type=template&id=87bb24f2&lang=pug"
import script from "./BotaoSucursales.vue?vue&type=script&lang=js"
export * from "./BotaoSucursales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports